import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
var Planos_modComponent = /** @class */ (function () {
    function Planos_modComponent(_formService) {
        this._formService = _formService;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            planos_mod: new FormControl('', Validators.required),
        });
        if (!JSON.parse(localStorage.getItem("planos_mod"))) {
            localStorage.setItem("planos_mod", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("planos_mod"));
            this.form.controls['planos_mod'].setValue(this.rows[0] ? this.rows[0].planos_mod : false);
        }
    }
    Planos_modComponent.prototype.add_planos_mod = function () {
        localStorage.setItem("planos_mod", JSON.stringify([]));
        this.actualRow = localStorage.getItem("planos_mod");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            planos_mod: this.form.value.planos_mod
        });
        localStorage.setItem("planos_mod", JSON.stringify(this.rows));
        this.form.reset(); //
        //this.planos_mod = JSON.parse(localStorage.getItem("planos_mod"));
    };
    Planos_modComponent.prototype.delete_planos_mod = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("planos_mod", JSON.stringify(this.rows));
            }
        }
    };
    return Planos_modComponent;
}());
export { Planos_modComponent };
